import { commentsData } from '@/mocks/home';

export default function CommentsSection() {
  return (
    <section id="comments" className="w-full py-16 md:py-20 bg-background-50">
      <div className="max-w-[900px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 mb-3">
            吃瓜群众说
          </h2>
          <p className="text-sm text-foreground-500">来自真实用户的使用反馈</p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {commentsData.map((comment) => (
            <div
              key={comment.id}
              className="bg-background-100 rounded-2xl p-6 border border-secondary-200/40 flex flex-col"
            >
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0 bg-secondary-200">
                  <img
                    src={comment.avatar}
                    alt={comment.name}
                    className="w-full h-full object-cover"
                    onError={(e) => {
                      const target = e.currentTarget;
                      target.style.display = 'none';
                    }}
                  />
                </div>
                <div>
                  <p className="text-sm font-medium text-foreground-800">{comment.name}</p>
                  <p className="text-xs text-foreground-400">{comment.time}</p>
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed flex-1 mb-4">
                "{comment.content}"
              </p>
              <div className="flex items-center gap-1 text-xs text-foreground-400">
                <i className="ri-thumb-up-line"></i>
                <span>{comment.likes}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}